// Character set constants for form validation
// see https://jira.shop-apotheke.com/browse/WSLAM-951 for details

const STANDARD = 'a-zßA-Zẞ'
const GRAVIS = 'àÀèÈìÌòÒùÙ'
const NASAL = 'ñõãÑÕÃ'
const SPECIAL_CHARACTERS = String.raw`Çç' \-._&/,~''`
const AKUT = 'áÁéÉíÍóÓúÚýÝ'
const ZIRCUMFLEX = 'âÂêÊîÎôÔûÛ'
const TREMA = 'ÄäǞǟЁёëḦḧÏïÖöȪȫṎṏÜüǕǖǗǘǙǚǛǜṺṻẄẅẌẍŸÿ'
const NUMERIC = '0-9'
const DOOR_CODE_EXTRA = '!@#$%&*)'

const ALLOWED_CHARACTERS = `${STANDARD}${GRAVIS}${AKUT}${ZIRCUMFLEX}${NASAL}${TREMA}${SPECIAL_CHARACTERS}`
const ALLOWED_CHARACTERS_WITH_NUMBERS = `${ALLOWED_CHARACTERS}${NUMERIC}`
const DOOR_CODE_CHARACTERS = `${ALLOWED_CHARACTERS_WITH_NUMBERS}${DOOR_CODE_EXTRA}`

const allowedCharactersRegex = new RegExp(`^[${ALLOWED_CHARACTERS}]+$`, 'u')
const allowedCharactersWithNumbersRegex = new RegExp(
  `^[${ALLOWED_CHARACTERS_WITH_NUMBERS}]+$`,
  'u',
)
const doorCodeCharactersRegex = new RegExp(`^[${DOOR_CODE_CHARACTERS}]+$`, 'u')

export const isAllowedCharacters = (value: string): boolean =>
  allowedCharactersRegex.test(value)

export const isAllowedCharactersWithNumbers = (value: string): boolean =>
  allowedCharactersWithNumbersRegex.test(value)

export const isDoorCodeCharacters = (value: string): boolean =>
  doorCodeCharactersRegex.test(value)
